//Add Admin
export const STATUS ="STATUS"
export const STATUS_SUCCESS = "STATUS_SUCCESS"
export const STATUS_FAIL = "STATUS_FAIL"